// extracted by mini-css-extract-plugin
export default {"changelogItem":"changelogItem__mscn7zcK","header":"header__AmvV8gPJ","date":"date__AZ38z8qd","description":"description__Z5cZCMbD","indicatorLabel":"indicatorLabel__zy9MbobC"};